module.exports = __webpack_public_path__ + "static/media/alert_train_selected.7ce244ef.svg";